import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from '@psspl/utils';
const TONE_CLASS = {
    neutral: 'bg-surface-overlay text-ink-secondary border-line-strong',
    brand: 'bg-brand-500/12 text-brand-300 border-brand-500/35',
    accent: 'bg-accent-500/12 text-accent-300 border-accent-500/35',
    success: 'bg-feedback-success/12 text-feedback-success border-feedback-success/35',
    warning: 'bg-feedback-warning/12 text-feedback-warning border-feedback-warning/35',
    danger: 'bg-feedback-danger/12 text-feedback-danger border-feedback-danger/35',
    info: 'bg-feedback-info/12 text-feedback-info border-feedback-info/35',
};
const SIZE_CLASS = {
    sm: 'h-5 px-1.5 text-[0.6875rem]',
    md: 'h-6 px-2 text-xs',
};
const BASE_CLASS = 'inline-flex items-center gap-1.5 whitespace-nowrap rounded-sm border font-medium';
const CAPS_CLASS = 'uppercase tracking-wider';
/**
 * Class recipe for a badge, for use on elements that are not `<span>` (for example
 * a badge-styled list item or a `<Link>`).
 */
export function badgeStyles({ tone = 'neutral', size = 'sm', caps = true, className, } = {}) {
    return cn(BASE_CLASS, caps && CAPS_CLASS, TONE_CLASS[tone], SIZE_CLASS[size], className);
}
/**
 * Small status or category label.
 *
 * Feedback tone is always paired with text, never used as the only carrier of
 * meaning. See docs/ui-guidelines.md section 3.
 */
export function Badge({ tone = 'neutral', size = 'sm', caps = true, icon, className, children, ...rest }) {
    return (_jsxs("span", { className: badgeStyles({ tone, size, caps, className }), ...rest, children: [icon === undefined ? null : (_jsx("span", { "aria-hidden": "true", className: "inline-flex", children: icon })), children] }));
}
//# sourceMappingURL=badge.js.map